<div class="modal-header">
    <h4 class="modal-title">Importar diagramaciones</h4>
    <button type="button" class="btn-close" mat-dialog-close [disabled]="isImporting"></button>
</div>
<mat-dialog-content class="mat-typography import-dialog-content" >
    <div class="modal-body" style="min-height: 20vh">
        <div *ngIf="initialLoading" class="text-center p-4">
            <mat-spinner diameter="50" class="mx-auto"></mat-spinner>
            <p class="mt-2">Cargando datos iniciales...</p>
        </div>

        <ng-container *ngIf="!initialLoading">
            <!-- Vista inicial: Centrada -->
            <div *ngIf="!fileName" class="initial-view">
                <form [formGroup]="form" class="w-100">
                    <ngx-file-drag-drop 
                        class="ngx-file_f" 
                        emptyPlaceholder="Arrastre o seleccione un archivo .json" 
                        formControlName="blob" 
                        (valueChanged)="onValueChange($event)">
                    </ngx-file-drag-drop>
                </form>
            </div>

            <!-- Vista con archivo cargado -->
            <div *ngIf="fileName" class="loaded-view">
                <div class="file-info-container">
                    <span class="file-name" [matTooltip]="fileName">{{ fileName }}</span>
                    <button
                        type="button"
                        class="remove-file-button"
                        (click)="resetFile()"
                        matTooltip="Quitar archivo"
                        aria-label="Quitar archivo"
                        [disabled]="isImporting">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <div *ngIf="diagrams.length > 0" class=" mt-3">
                    Total de registros: <strong>{{ diagrams.length }}</strong>.
                </div>
                <br>
                <mat-checkbox *ngIf="diagrams.length > 0" [(ngModel)]="stopOnError" class="mb-3">
                    Detener el proceso si una diagramación no puede importarse
                </mat-checkbox>

                <div 
                    *ngIf="diagrams.length > 0" 
                    class="table-responsive" 
                    cdkScrollable 
                    cdkDropList 
                    (cdkDropListDropped)="drop($event)"
                    [cdkDropListDisabled]="isImporting">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Orden</th>
                                <th>Alias</th>
                                <th>Medio</th>
                                <th>POP</th>
                                <th>Posición</th>
                                <th>VoBos</th>
                                <th class="text-center">Estatus</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let diagram of diagrams; let i = index" cdkDrag [cdkDragDisabled]="isImporting || isDiagramSaved(diagram)">
                                <div *cdkDragPreview class="drag-preview">
                                    <mat-icon>drag_indicator</mat-icon>
                                    <span>{{ diagram.alias }}</span> ||
                                    <span>{{ diagram.medio }}</span> ||
                                    <span>{{ diagram.pop }}</span> ||
                                    <span> Posición: {{ diagram.posicion }}</span>
                                </div>
                                <td class="drag-handle text-center" cdkDragHandle>
                                    <mat-icon>drag_indicator</mat-icon>
                                </td>
                                <td>
                                    <mat-form-field appearance="outline" class="w-100">
                                        <input matInput placeholder="Alias" [(ngModel)]="diagram.alias" [disabled]="isImporting || diagram.isSaving || isDiagramSaved(diagram)">
                                    </mat-form-field>
                                </td>
                                <td>
                                    <app-generic-autocomplete
                                        [dataSource]="filteredMedios"
                                        [(selectedValue)]="diagram.medio_id"
                                        (selectedValueChange)="onMedioChange(diagram, $event, true)"                                
                                        [disabled]="isImporting || diagram.isSaving || isDiagramSaved(diagram)"
                                        [initialText]="diagram.medio"
                                        placeholder="Medio"
                                        displayField="nombre"
                                        valueField="id">
                                    </app-generic-autocomplete>
                                    <mat-error *ngIf="diagram.medioError">{{ diagram.medioError }}</mat-error>                            
                                </td>
                                <td>
                                    <app-generic-autocomplete
                                        [dataSource]="diagram.availablePops"
                                        [(selectedValue)]="diagram.pop_id"
                                        (selectedValueChange)="onPopChange(diagram, $event)"
                                        [initialText]="diagram.pop"                                
                                        [disabled]="isImporting || !diagram.medio_id || diagram.isSaving || isDiagramSaved(diagram)"
                                        placeholder="POP"
                                        displayField="nombre"
                                        valueField="id">
                                    </app-generic-autocomplete>
                                    <mat-error *ngIf="diagram.popError">{{ diagram.popError }}</mat-error>                            
                                </td>
                                <td>
                                    <mat-form-field appearance="outline" class="w-100" *ngIf="diagram.pop_sel?.posiciones > 0">
                                        <mat-label>Posición</mat-label>
                                        <mat-select [(ngModel)]="diagram.posicion" [disabled]="isImporting || !diagram.pop_id || diagram.isSaving || isDiagramSaved(diagram)" (selectionChange)="onPositionChange(diagram)">
                                            <mat-option *ngFor="let pos of diagram.availablePositions" [value]="pos">{{ pos }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span *ngIf="!diagram.pop_sel || diagram.pop_sel?.posiciones == 0">N/A</span>
                                    <mat-error *ngIf="diagram.positionError">{{ diagram.positionError }}</mat-error>                            
                                </td>
                                <td class="text-center">
                                    <button mat-stroked-button color="primary" (click)="openVobosModal(diagram)" [disabled]="isImporting || diagram.isSaving || isDiagramSaved(diagram)">
                                        VoBos
                                    </button>
                                    <mat-error *ngIf="!diagram.vobosAreValid"> Configuración de VoBos incompleta.</mat-error>
                                </td>
                                <td class="text-center">
                                    <div [ngSwitch]="diagram.status">
                                        <mat-spinner *ngSwitchCase="'importing'" diameter="24" class="mx-auto"></mat-spinner>
                                        <span *ngSwitchCase="'completed'" class="badge bg-success">Completado</span>
                                        <div *ngSwitchCase="'alerts'">
                                            <span class="badge bg-success">Completado</span>
                                            <button mat-stroked-button color="accent" class="badge-alert ms-2" (click)="showDiagramAlerts(diagram)">
                                                Alertas ({{diagram.alerts.length}})
                                            </button>
                                        </div>
                                        <div *ngSwitchCase="'error'">
                                            <button mat-stroked-button color="warn" class="badge-alert" (click)="showDiagramError(diagram)">{{ diagram.savedId != null ? 'Revisar guardado' : 'No importado' }}</button>
                                        </div>                                
                                        <span *ngSwitchDefault>Pendiente</span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <button mat-icon-button color="warn" (click)="discardDiagram(i)" matTooltip="Descartar" [disabled]="isImporting">
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close [disabled]="isImporting">Cancelar</button>
    <ng-container *ngIf="!importCompleted || hasPendingDiagrams">
        <button mat-raised-button color="primary" (click)="importDiagrams()" [disabled]="!areAllDiagramsValid || isImporting || initialLoading">
            <mat-icon>input</mat-icon> Importar
        </button>
    </ng-container>
</mat-dialog-actions>
